




import { Component, Vue } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import ReviewDetail from '@/views/product/review/ReviewDetail.vue';

@Component({
  components: { AdminIframe, ReviewDetail },
})
export default class ReviewDetailPopupIframe extends Vue {

  private get remoteSrc() {
    const query = this.$route.query;
    const params = this.$route.params;
    const queryObject = { serviceType: 'PREMIUM', ...query, ...params };
    const queryString = new URLSearchParams(queryObject).toString();

    return process.env.VUE_APP_ADMIN_REMOTE_URL + '/popup/review-detail?' + queryString;
  }
}
